import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";

const MenuModal = (props) => {
  const data = props.dataModal;
  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  const addHandler = () => {
    props.closeModal();
    setTimeout(() => {
      props.setModalType("add", data);
      props.setModalAdd(data);
    }, 150);
  };

  const editHandler = () => {
    props.closeModal();
    setTimeout(() => {
      props.setModalType("edit", data);
      props.setModalEdit(data);
    }, 150);
  };

  const undoHandler = () => {
    props.closeModal();
    setTimeout(() => {
      props.setModalType("undo", data);
      props.setModalUndo(data);
    }, 150);
  };

  const deleteHandler = () => {
    props.closeModal();
    setTimeout(() => {
      props.setModalType("delete", data);
      props.setModalDelete(data);
    }, 150);
  };

  const closeHandler = () => {
    props.closeModal("menu", data);
  };

  const buttonList = [
    {
      id: 1,
      icon: "fa fa-user me-1",
      title: "Tambah Tukang",
      button: "btn-success me-2",
      hide: data.isModif === "INSERT" ? true : false,
      onClick: addHandler,
    },
    {
      id: 2,
      icon: "fa fa-pencil me-1",
      title: "Koreksi Upah",
      button: "btn-warning me-2",
      hide: false,
      onClick: editHandler,
    },
    {
      id: 3,
      icon: "fa fa-mail-reply me-1",
      title: "Undo Koreksi",
      button: "btn-info me-2",
      hide: data.isModif === "INSERT" ? true : false,
      onClick: undoHandler,
    },
    {
      id: 4,
      icon: "fa fa-trash me-1",
      title: "Delete Worker",
      button: "btn-danger me-2",
      hide: false,
      onClick: deleteHandler,
    },
  ];

  return (
    <Modal
      activeModal={activeModal}
      modalType="modal-lg"
      activeStyle={activeStyle}
      title="Menu Detail"
      closeClick={closeHandler}
      type="Detail"
    >
      <div className="table-responsive">
        <table className="table text-nowrap text-md-nowrap text-center">
          <thead>
            <tr>
              <th>Tanggal</th>
              <th>Client Name</th>
              <th>Worker Name</th>
              <th>Skill Worker</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{data.attendanceDate}</td>
              <td>{data.clientName}</td>
              <td>{data.workerName}</td>
              <td>{data.skillName}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {buttonList.map((button) => (
        <Button
          key={button.id}
          icon={button.icon}
          title={button.title}
          button={button.button}
          onClick={button.onClick}
          hide={button.hide}
        />
      ))}
    </Modal>
  );
};

export default MenuModal;
